<mat-card>
  <mat-card-header>
    <mat-card-title>Occupation Details</mat-card-title>
  </mat-card-header>

  <mat-card-content class="m-t-1">


    @if (!isVisit){
    <app-text-input label="What is your usual occupation" [control]="occupationForm.controls.occupation" shortLabel="Occupation">
    </app-text-input>


    <app-radio-input label="Have you previously worked full-time in your occupation?"
      [control]="occupationForm.controls.workedIn" shortLabel="Worked In"
      [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
      [submitAttempted]="submitAttempted">
    </app-radio-input>
    }

    @if (model.occupation!.workedIn === 'true' || isVisit ) {
    <div class="section-label">
      <mat-label>{{ employmentHistoryLabel() }}</mat-label>
    </div>

    @if (model.occupation!.roles.length > 0) {
       @if(!(isMobile$ | async)) { 
    <table mat-table [dataSource]="roleDataSource" class="mat-elevation-z1">

      <ng-container matColumnDef="employer">
        <th mat-header-cell *matHeaderCellDef>Employer</th>
        <td mat-cell *matCellDef="let element">{{element.employerName}}</td>
      </ng-container>

      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef>Country</th>
        <td mat-cell *matCellDef="let element">{{element.employerCountry?.Value}}</td>
      </ng-container>

      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef>Position</th>
        <td mat-cell *matCellDef="let element">{{element.position}}</td>
      </ng-container>

      <ng-container matColumnDef="start">
        <th mat-header-cell *matHeaderCellDef>Start</th>
        <td mat-cell *matCellDef="let element">{{element.start | date: 'dd/MM/yyyy'}}</td>
      </ng-container>

      <ng-container matColumnDef="end">
        <th mat-header-cell *matHeaderCellDef>End</th>
        <td mat-cell *matCellDef="let element">{{element.end | date: 'dd/MM/yyyy'}}</td>
      </ng-container>

      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef>Edit</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <button mat-icon-button (click)="edit(i)">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef>Delete</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <button mat-icon-button color="warn" (click)="remove(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
      }
      @if(isMobile$ | async) {
        <div class="mobile-cards">
          @for(element of model.occupation!.roles; track element; let i = $index) {
             <mat-card  class="mobile-card">
          <mat-card-content>
            <div class="mobile-card-details">
              <div class="mobile-card-item">
                <span class="label">Employer:</span>
                <span class="value">{{element.employerName}}</span>
              </div>
              <div class="mobile-card-item">
                <span class="label">Country:</span>
                <span class="value">{{element.employerCountry?.Value}}</span>
              </div>
              <div class="mobile-card-item">
                <span class="label">Position:</span>
                <span class="value">{{element.position}}</span>
              </div>
              <div class="mobile-card-item">
                <span class="label">Start:</span>
                <span class="value">{{element.start | date: 'dd/MM/yyyy'}}</span>
              </div>
              <div class="mobile-card-item">
                <span class="label">End:</span>
                <span class="value">{{element.end | date: 'dd/MM/yyyy'}}</span>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

          }
        </div>
      }
    }

    <button mat-raised-button color="primary" (click)="add()">Add Employment</button>
    }

    @if (isSkilled) {
    <div class="label-with-tooltip">
      <span>Have you completed a gazetted professional year in Australia in the last 48 months?</span>
      <button mat-icon-button [matTooltip]="professionalHelpLabel" matTooltipClass="tooltip-multiline" tabindex="-1"
        type="button">
        <mat-icon>info</mat-icon>
      </button>

    </div>
    <app-radio-input label="" [control]="occupationForm.controls.professionalYear" shortLabel="Professional Year"
      [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
    </app-radio-input>
    }

  </mat-card-content>
</mat-card>